export const pricingPlans = [
  {
    id: 'starter',
    name: '启航版',
    subtitle: '适合中小企业入门',
    price: '9,800',
    period: '/年',
    description: '快速开启能源数字化管理之旅',
    popular: false,
    features: [
      { text: '最多 50 台设备接入', included: true },
      { text: '实时能耗监测仪表盘', included: true },
      { text: '基础能耗分析报告', included: true },
      { text: '邮件告警通知', included: true },
      { text: '7x24 在线客服支持', included: true },
      { text: 'AI 智能分析', included: false },
      { text: '预测性维护', included: false },
      { text: '碳排放追踪', included: false },
      { text: '企业工具集成', included: false },
      { text: '绿色工厂申报辅导', included: false },
    ],
    cta: '免费试用',
    ctaStyle: 'outline' as const,
  },
  {
    id: 'professional',
    name: '专业版',
    subtitle: '适合中型企业深度管理',
    price: '29,800',
    period: '/年',
    description: 'AI 驱动的全方位能源管理',
    popular: true,
    features: [
      { text: '最多 200 台设备接入', included: true },
      { text: '实时能耗监测仪表盘', included: true },
      { text: '高级能耗分析与对标', included: true },
      { text: '多渠道告警（邮件/短信/钉钉）', included: true },
      { text: '专属客户成功经理', included: true },
      { text: 'AI 智能分析与优化建议', included: true },
      { text: '预测性维护（基础版）', included: true },
      { text: '碳排放追踪与核算', included: true },
      { text: '企业工具集成（钉钉/飞书）', included: true },
      { text: '绿色工厂申报辅导', included: false },
    ],
    cta: '预约演示',
    ctaStyle: 'primary' as const,
  },
  {
    id: 'enterprise',
    name: '企业版',
    subtitle: '适合大型集团全面部署',
    price: '定制',
    period: '',
    description: '端到端能源与碳管理解决方案',
    popular: false,
    features: [
      { text: '无限设备接入', included: true },
      { text: '实时能耗监测仪表盘', included: true },
      { text: '定制化分析报告与模板', included: true },
      { text: '全渠道告警与工单系统', included: true },
      { text: '7x24 专属技术支持', included: true },
      { text: 'AI 智能分析与工艺优化', included: true },
      { text: '预测性维护（高级版）', included: true },
      { text: '全链路碳排放管理', included: true },
      { text: '全平台集成 + API 开放', included: true },
      { text: '绿色工厂/CCER/CBAM 全流程', included: true },
    ],
    cta: '联系销售',
    ctaStyle: 'outline' as const,
  },
];

export const pricingAddOns = [
  {
    name: '额外设备接入',
    description: '超出套餐包含数量的设备',
    price: '50元/台/年',
  },
  {
    name: '高级 AI 分析模块',
    description: '工艺级能耗优化与预测',
    price: '5,000元/年',
  },
  {
    name: '碳合规服务包',
    description: '绿色工厂申报 + CCER 开发 + CBAM 申报',
    price: '15,000元/项目',
  },
  {
    name: '专属部署',
    description: '私有化部署 + 数据隔离',
    price: '定制报价',
  },
];

export const pricingFaqs = [
  {
    question: '可以免费试用吗？',
    answer: '当然可以！启航版和专业版均提供 14 天免费试用，无需绑定支付方式。试用期间可体验全部功能，到期后自动降级为免费版（保留基础监测功能）。',
  },
  {
    question: '如何升级或降级套餐？',
    answer: '您可以随时在控制台升级套餐，升级后立即生效，按剩余天数比例补差价。降级将在当前计费周期结束后生效，已支付的费用不予退还。',
  },
  {
    question: '企业版如何定价？',
    answer: '企业版根据您的设备数量、功能需求和部署方式定制报价。我们的销售团队会在了解您的具体需求后，提供详细的方案和报价。通常企业版的年费在 8-30 万元之间。',
  },
  {
    question: '数据安全如何保障？',
    answer: 'Firmai 采用银行级数据加密（AES-256），所有数据存储在阿里云/腾讯云的企业级服务器上，通过等保三级认证。企业版支持私有化部署，数据完全由您掌控。',
  },
  {
    question: '是否支持多厂区管理？',
    answer: '支持。专业版和企业版均支持多厂区、多层级管理。您可以为每个厂区设置独立的监测点和权限，总部可查看汇总数据和跨厂区对比分析。',
  },
  {
    question: '碳合规服务包含哪些内容？',
    answer: '碳合规服务包包括：绿色工厂申报全流程辅导（含 ISO 50001 认证）、CCER 项目设计与备案、CBAM 季度报告自动生成。每个项目由专属顾问一对一服务。',
  },
];